var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBracketArrowStartGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.49691e-07L3.5 6.1196e-07C3.77614 6.60242e-07 4 0.223859 4 0.500001C4 0.776144 3.77614 1 3.5 1L2.5 1C1.67157 1 1 1.67157 1 2.5L0.999998 10.5C0.999998 11.3284 1.67157 12 2.5 12L3.5 12C3.77614 12 4 12.2239 4 12.5C4 12.7761 3.77614 13 3.5 13L2 13C0.895428 13 -2.11643e-06 12.1046 -1.9233e-06 11L-3.49691e-07 2C-1.56562e-07 0.895431 0.895432 1.56562e-07 2 3.49691e-07Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8301 3.13921L13.8605 6.16392C14.0465 6.34953 14.0465 6.65047 13.8605 6.83608L10.8301 9.86079C10.6441 10.0464 10.3426 10.0464 10.1566 9.86079C9.97067 9.67518 9.97067 9.37424 10.1566 9.18863L12.3742 6.97529L4 6.97529L4 6.02471L12.3742 6.02471L10.1566 3.81137C9.97067 3.62576 9.97067 3.32482 10.1566 3.13921C10.3426 2.9536 10.6441 2.9536 10.8301 3.13921Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketArrowStartGrey);
export default __webpack_public_path__ + "static/media/bracket-arrow-start-grey.7f7c45563dbd354b5c748eb1aa5be434.svg";
export { ForwardRef as ReactComponent };